(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-promo-regalo-zweigart"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('promo-hero')) {
    class PromoHero extends HTMLElement {
      connectedCallback() {
        if (this.isExpired()) {
          this.hidden = true;
          return;
        }
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.fan = this.querySelector('[data-ph-fan]');
        this.cards = Array.from(this.querySelectorAll('[data-ph-card]'));
        this.nameEl = this.querySelector('[data-ph-name]');
        this.current = -1;
        this.classList.add('is-ready');
        if (!this.fan || !this.cards.length) return;

        this.cards.forEach((card, i) => {
          card.addEventListener('click', () => {
            this.pick(i);
            this.pauseFor(6000);
          });
        });

        if (this.reduced) return;

        // Reparto inicial: del montón al abanico
        this.fan.classList.add('is-stacked');
        requestAnimationFrame(() => requestAnimationFrame(() => this.fan.classList.remove('is-stacked')));
        this.dealTimer = setTimeout(() => this.fan.classList.add('is-dealt'), 1300);

        this.paused = false;
        this.addEventListener('mouseenter', () => { this.paused = true; });
        this.addEventListener('mouseleave', () => { this.paused = false; });
        this.addEventListener('focusin', () => { this.paused = true; });
        this.addEventListener('focusout', () => { this.paused = false; });

        this.visible = true;
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => { this.visible = entries[0].isIntersecting; });
          this.io.observe(this);
        }

        this.startTimer = setTimeout(() => {
          this.pickRandom();
          this.timer = setInterval(() => {
            if (!this.paused && this.visible && !document.hidden) this.pickRandom();
          }, 2400);
        }, 1400);
      }

      disconnectedCallback() {
        clearTimeout(this.startTimer);
        clearTimeout(this.dealTimer);
        clearTimeout(this.resumeTimer);
        clearInterval(this.timer);
        if (this.io) this.io.disconnect();
      }

      isExpired() {
        if (this.hasAttribute('data-editor')) return false;
        const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(this.dataset.end || '');
        if (!m) return false;
        return new Date() > new Date(+m[1], +m[2] - 1, +m[3], 23, 59, 59);
      }

      pickRandom() {
        if (this.cards.length < 2) return this.pick(0);
        let next = this.current;
        while (next === this.current) next = Math.floor(Math.random() * this.cards.length);
        this.pick(next);
      }

      pick(i) {
        this.current = i;
        this.cards.forEach((card, k) => card.classList.toggle('is-picked', k === i));
        if (this.nameEl) this.nameEl.textContent = this.cards[i].dataset.name || '';
      }

      pauseFor(ms) {
        this.paused = true;
        clearTimeout(this.resumeTimer);
        this.resumeTimer = setTimeout(() => { this.paused = false; }, ms);
      }
    }
    customElements.define('promo-hero', PromoHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hub-accesorios"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('accessory-hub')) {
    class AccessoryHub extends HTMLElement {
      connectedCallback() {
        try {
          this.t = JSON.parse(this.querySelector('[data-ah-i18n]').textContent);
        } catch (e) {
          this.t = {};
        }
        this.classList.add('is-ready');
        this.initFilters();
        this.initHoop();
        this.initReadMore();
        this.onBlockSelect = (e) => {
          if (this.contains(e.target) && e.target.matches('[data-ah-card][hidden]')) this.filter('all');
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      fill(tpl, values) {
        return Object.keys(values).reduce((s, k) => s.split(`[${k}]`).join(values[k]), tpl || '');
      }

      /* ---------- Filtros ---------- */
      initFilters() {
        this.chips = Array.from(this.querySelectorAll('[data-ah-filter]'));
        this.cards = Array.from(this.querySelectorAll('[data-ah-card]'));
        this.status = this.querySelector('[data-ah-status]');
        const row = this.querySelector('.ah-filters');
        const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.chips.forEach((chip) => {
          chip.addEventListener('click', () => {
            this.filter(chip.dataset.ahFilter);
            if (row && row.scrollWidth > row.clientWidth) {
              row.scrollTo({
                left: chip.offsetLeft - (row.clientWidth - chip.offsetWidth) / 2,
                behavior: smooth ? 'smooth' : 'auto'
              });
            }
          });
        });

        if (row) {
          const markEnd = () => row.classList.toggle('is-end', row.scrollLeft + row.clientWidth >= row.scrollWidth - 4);
          row.addEventListener('scroll', markEnd, { passive: true });
          markEnd();
        }
      }

      filter(value) {
        let visible = 0;
        this.chips.forEach((chip) => chip.setAttribute('aria-pressed', String(chip.dataset.ahFilter === value)));
        this.cards.forEach((card) => {
          const show = value === 'all' || card.dataset.group === value;
          card.hidden = !show;
          if (show) visible += 1;
        });
        if (this.status) {
          this.status.textContent = this.fill(visible === 1 ? this.t.one : this.t.other, { n: visible });
        }
      }

      /* ---------- Calculadora de bastidor ---------- */
      initHoop() {
        const box = this.querySelector('[data-ah-hoop]');
        if (!box) return;

        const parse = (str) => (str || '')
          .split(',')
          .map((v) => parseFloat(v))
          .filter((v) => v > 0)
          .sort((a, b) => a - b);

        this.hoop = {
          box,
          sizes: { round: parse(box.dataset.round), square: parse(box.dataset.square) },
          w: box.querySelector('[name="ah-w"]'),
          h: box.querySelector('[name="ah-h"]'),
          m: box.querySelector('[name="ah-m"]'),
          spi: box.querySelector('[name="ah-spi"]'),
          fabric: box.querySelector('[data-ah-fabric]'),
          units: Array.from(box.querySelectorAll('[data-ah-unit]')),
          design: box.querySelector('[data-ah-design]'),
          figs: Array.from(box.querySelectorAll('[data-ah-fig]')),
          unit: 'cm',
          nf: new Intl.NumberFormat(document.documentElement.lang || 'es', { maximumFractionDigits: 1 })
        };

        box.querySelectorAll('input[type="radio"]').forEach((radio) => {
          radio.addEventListener('change', () => this.setUnit(radio.value));
        });
        box.addEventListener('input', (e) => {
          if (e.target.type !== 'radio') this.updateHoop();
        });
        box.addEventListener('change', (e) => {
          if (e.target === this.hoop.spi) this.updateHoop();
        });

        box.hidden = false;
        this.updateHoop();
      }

      setUnit(unit) {
        const h = this.hoop;
        if (unit === h.unit) return;
        const spi = parseFloat(h.spi.value) || 14;
        [h.w, h.h].forEach((input) => {
          const v = parseFloat(input.value);
          if (!(v > 0)) return;
          input.value = unit === 'st'
            ? Math.round((v / 2.54) * spi)
            : Math.round(((v / spi) * 2.54) * 10) / 10;
        });
        h.unit = unit;
        h.fabric.hidden = unit !== 'st';
        h.units.forEach((el) => { el.textContent = unit === 'st' ? this.t.stitches : this.t.cm; });
        [h.w, h.h].forEach((input) => { input.step = unit === 'st' ? '1' : 'any'; });
        this.updateHoop();
      }

      updateHoop() {
        const h = this.hoop;
        let w = parseFloat(h.w.value) || 0;
        let ht = parseFloat(h.h.value) || 0;
        const m = Math.max(0, parseFloat(h.m.value) || 0);

        if (h.unit === 'st') {
          const spi = parseFloat(h.spi.value) || 14;
          w = (w / spi) * 2.54;
          ht = (ht / spi) * 2.54;
          h.design.textContent = w && ht ? this.fill(this.t.design, { w: h.nf.format(w), h: h.nf.format(ht) }) : '';
        } else {
          h.design.textContent = '';
        }

        const valid = w > 0 && ht > 0;
        const need = { round: Math.hypot(w, ht) + m * 2, square: Math.max(w, ht) + m * 2 };
        const picks = {};
        Object.keys(h.sizes).forEach((shape) => {
          const list = h.sizes[shape];
          if (!list.length) return;
          const fit = list.find((s) => s >= need[shape] - 0.001);
          picks[shape] = { size: fit || list[list.length - 1], tooBig: !fit };
        });

        const shown = Object.values(picks).map((p) => p.size);
        const S = Math.max(...shown, valid ? w : 0, valid ? ht : 0, 1) * 1.16 + 3;

        h.figs.forEach((fig) => {
          const shape = fig.dataset.ahFig;
          const pick = picks[shape];
          const sizeEl = fig.querySelector('[data-ah-size]');
          const noteEl = fig.querySelector('[data-ah-note]');
          const svg = fig.querySelector('[data-ah-svg]');
          if (!pick || !valid) {
            sizeEl.textContent = '—';
            noteEl.textContent = '';
            fig.classList.remove('is-too-big');
            this.drawHoop(svg, shape, pick ? pick.size : 20, 0, 0, S);
            return;
          }
          const s = h.nf.format(pick.size);
          sizeEl.textContent = shape === 'round' ? `Ø ${s} cm` : `${s} × ${s} cm`;
          noteEl.textContent = pick.tooBig ? this.fill(this.t.tooBig, { s }) : '';
          fig.classList.toggle('is-too-big', pick.tooBig);
          this.drawHoop(svg, shape, pick.size, w, ht, S);
        });
      }

      drawHoop(svg, shape, size, w, h, S) {
        const NS = 'http://www.w3.org/2000/svg';
        const el = (name, attrs, parent) => {
          const node = document.createElementNS(NS, name);
          Object.keys(attrs).forEach((k) => node.setAttribute(k, attrs[k]));
          (parent || svg).appendChild(node);
          return node;
        };
        const f = (n) => Math.round(n * 1000) / 1000;

        svg.textContent = '';
        svg.setAttribute('viewBox', `0 0 ${f(S)} ${f(S)}`);

        const cx = S / 2;
        const cy = S / 2 + S * 0.03;
        const r = size / 2;
        const ring = S * 0.024;
        const id = `ah-x-${this.id || Math.random().toString(36).slice(2)}-${shape}`;

        const defs = el('defs', {});
        const p = S / 40;
        const pattern = el('pattern', { id, width: f(p), height: f(p), patternUnits: 'userSpaceOnUse', x: f(cx - w / 2), y: f(cy - h / 2) }, defs);
        el('path', {
          d: `M${f(p * 0.2)} ${f(p * 0.2)}L${f(p * 0.8)} ${f(p * 0.8)}M${f(p * 0.8)} ${f(p * 0.2)}L${f(p * 0.2)} ${f(p * 0.8)}`,
          class: 'ah-svg-x',
          'stroke-width': f(p * 0.13)
        }, pattern);

        if (shape === 'round') {
          el('circle', { cx: f(cx), cy: f(cy), r: f(r), class: 'ah-svg-fabric' });
        } else {
          el('rect', { x: f(cx - r), y: f(cy - r), width: f(size), height: f(size), rx: f(ring * 1.2), class: 'ah-svg-fabric' });
        }

        if (w > 0 && h > 0) {
          const clip = el('clipPath', { id: `${id}-clip` }, defs);
          if (shape === 'round') {
            el('circle', { cx: f(cx), cy: f(cy), r: f(r) }, clip);
          } else {
            el('rect', { x: f(cx - r), y: f(cy - r), width: f(size), height: f(size) }, clip);
          }
          const box = { x: f(cx - w / 2), y: f(cy - h / 2), width: f(w), height: f(h) };
          const drawDesign = (parent) => {
            el('rect', Object.assign({ class: 'ah-svg-design-bg' }, box), parent);
            el('rect', Object.assign({ fill: `url(#${id})`, class: 'ah-svg-design', 'stroke-width': f(ring * 0.22) }, box), parent);
          };
          drawDesign(el('g', { class: 'ah-svg-outside' }));
          drawDesign(el('g', { 'clip-path': `url(#${id}-clip)` }));
        }

        if (shape === 'round') {
          el('circle', { cx: f(cx), cy: f(cy), r: f(r + ring * 0.5), class: 'ah-svg-ring', 'stroke-width': f(ring) });
          el('circle', { cx: f(cx), cy: f(cy), r: f(r + ring * 1.45), class: 'ah-svg-ring ah-svg-ring--outer', 'stroke-width': f(ring * 0.9) });
        } else {
          const o1 = ring * 0.5;
          const o2 = ring * 1.45;
          el('rect', { x: f(cx - r - o1), y: f(cy - r - o1), width: f(size + o1 * 2), height: f(size + o1 * 2), rx: f(ring * 1.6), class: 'ah-svg-ring', 'stroke-width': f(ring) });
          el('rect', { x: f(cx - r - o2), y: f(cy - r - o2), width: f(size + o2 * 2), height: f(size + o2 * 2), rx: f(ring * 2.2), class: 'ah-svg-ring ah-svg-ring--outer', 'stroke-width': f(ring * 0.9) });
        }

        const top = cy - r - ring * 1.45;
        const tabW = ring * 1.3;
        const tabH = ring * 3;
        el('rect', { x: f(cx - tabW * 1.15), y: f(top - tabH + ring * 0.5), width: f(tabW), height: f(tabH), rx: f(ring * 0.3), class: 'ah-svg-clamp' });
        el('rect', { x: f(cx + tabW * 0.15), y: f(top - tabH + ring * 0.5), width: f(tabW), height: f(tabH), rx: f(ring * 0.3), class: 'ah-svg-clamp' });
        el('rect', { x: f(cx - tabW * 2), y: f(top - tabH * 0.62), width: f(tabW * 4), height: f(ring * 0.75), rx: f(ring * 0.37), class: 'ah-svg-screw' });
      }

      /* ---------- Leer más ---------- */
      initReadMore() {
        const body = this.querySelector('[data-ah-collapsible]');
        const btn = this.querySelector('[data-ah-more]');
        if (!body || !btn || body.scrollHeight <= 440) return;
        body.classList.add('is-collapsed');
        btn.hidden = false;
        btn.addEventListener('click', () => {
          const expanded = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', String(!expanded));
          body.classList.toggle('is-collapsed', expanded);
          btn.textContent = expanded ? btn.dataset.more : btn.dataset.less;
        });
      }
    }
    customElements.define('accessory-hub', AccessoryHub);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hub-navidad"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('christmas-hub')) {
    class ChristmasHub extends HTMLElement {
      connectedCallback() {
        try {
          this.t = JSON.parse(this.querySelector('[data-xh-i18n]').textContent);
        } catch (e) {
          this.t = {};
        }
        this.initSeason();
        this.initReadMore();
      }

      fill(tpl, values) {
        return Object.keys(values).reduce((s, k) => s.split(`[${k}]`).join(values[k]), tpl || '');
      }

      /* Días que faltan hasta Nochebuena (fecha local del visitante) */
      daysToEve() {
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        let eve = new Date(today.getFullYear(), 11, 24);
        if (today > eve) eve = new Date(today.getFullYear() + 1, 11, 24);
        return { today, days: Math.round((eve - today) / 86400000) };
      }

      initSeason() {
        const { today, days } = this.daysToEve();
        // Fuera de temporada (del 25 de diciembre a finales de febrero) no se muestra nada.
        if (days > 300) return;

        const box = this.querySelector('[data-xh-count]');
        if (box) {
          const daysEl = box.querySelector('[data-xh-days]');
          daysEl.textContent = days === 0
            ? this.t.today
            : this.fill(days === 1 ? this.t.one : this.t.other, { n: days });

          const deadlineEl = box.querySelector('[data-xh-deadline]');
          const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(this.t.deadlineDate || '');
          if (m) {
            const deadline = new Date(+m[1], +m[2] - 1, +m[3]);
            let text = '';
            if (today <= deadline) {
              const lang = document.documentElement.lang || 'es';
              const date = new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'long' }).format(deadline);
              text = this.fill(this.t.deadline, { fecha: date });
            } else {
              text = this.t.deadlinePassed || '';
            }
            if (text) {
              deadlineEl.textContent = text;
              deadlineEl.hidden = false;
            }
          }
          box.hidden = false;
        }

        const rows = Array.from(this.querySelectorAll('[data-xh-row]'));
        if (!rows.length) return;
        const left = days - (parseInt(this.t.shipping, 10) || 0);
        rows.forEach((row) => {
          const min = parseInt(row.dataset.min, 10) || 0;
          const max = parseInt(row.dataset.max, 10) || min;
          const state = left >= max ? 'ok' : left >= min ? 'tight' : 'late';
          const cell = row.querySelector('[data-xh-status]');
          const chip = document.createElement('span');
          chip.className = `xh-chip xh-chip--${state}`;
          chip.textContent = this.t[state] || '';
          cell.textContent = '';
          cell.appendChild(chip);
          cell.hidden = false;
        });
        this.querySelectorAll('[data-xh-status-col]').forEach((el) => { el.hidden = false; });
      }

      initReadMore() {
        const body = this.querySelector('[data-xh-collapsible]');
        const btn = this.querySelector('[data-xh-more]');
        if (!body || !btn || body.scrollHeight <= 440) return;
        body.classList.add('is-collapsed');
        btn.hidden = false;
        btn.addEventListener('click', () => {
          const expanded = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', String(!expanded));
          body.classList.toggle('is-collapsed', expanded);
          btn.textContent = expanded ? btn.dataset.more : btn.dataset.less;
        });
      }
    }
    customElements.define('christmas-hub', ChristmasHub);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hub-telas"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fabric-hub')) {
    class FabricHub extends HTMLElement {
      connectedCallback() {
        this.classList.add('is-ready');
        this.initFilters();
        this.initCalc();
        this.initReadMore();
        this.onBlockSelect = (e) => {
          if (this.contains(e.target) && e.target.matches('[data-fh-card][hidden]')) this.filter('all');
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      initFilters() {
        this.chips = Array.from(this.querySelectorAll('[data-fh-filter]'));
        this.cards = Array.from(this.querySelectorAll('[data-fh-card]'));
        this.status = this.querySelector('[data-fh-status]');
        const row = this.querySelector('.fh-filters');
        const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.chips.forEach((chip) => {
          chip.addEventListener('click', () => {
            this.filter(chip.dataset.fhFilter);
            if (row && row.scrollWidth > row.clientWidth) {
              row.scrollTo({ left: chip.offsetLeft - (row.clientWidth - chip.offsetWidth) / 2, behavior: smooth ? 'smooth' : 'auto' });
            }
          });
        });
        if (row) {
          const markEnd = () => row.classList.toggle('is-end', row.scrollLeft + row.clientWidth >= row.scrollWidth - 4);
          row.addEventListener('scroll', markEnd, { passive: true });
          markEnd();
        }
      }

      filter(value) {
        let visible = 0;
        this.chips.forEach((chip) => chip.setAttribute('aria-pressed', String(chip.dataset.fhFilter === value)));
        this.cards.forEach((card) => {
          const show = value === 'all' || card.dataset.group === value;
          card.hidden = !show;
          if (show) visible += 1;
        });
        if (this.status) {
          const tpl = visible === 1 ? this.dataset.one : this.dataset.other;
          this.status.textContent = tpl.replace('[n]', visible);
        }
      }

      initCalc() {
        const box = this.querySelector('[data-fh-calc]');
        if (!box) return;
        const w = box.querySelector('[name="fh-w"]');
        const h = box.querySelector('[name="fh-h"]');
        const m = box.querySelector('[name="fh-m"]');
        const rows = Array.from(this.querySelectorAll('tr[data-spi]'));
        const fabricLabel = box.dataset.labelFabric || '';
        const nf = new Intl.NumberFormat(document.documentElement.lang || 'es', { maximumFractionDigits: 1 });

        box.hidden = false;
        this.querySelectorAll('[data-fh-size], [data-fh-size-col]').forEach((el) => { el.hidden = false; });

        const update = () => {
          const sw = parseFloat(w.value) || 0;
          const sh = parseFloat(h.value) || 0;
          const margin = Math.max(0, parseFloat(m.value) || 0);
          rows.forEach((row) => {
            const cell = row.querySelector('[data-fh-size]');
            const spi = parseFloat(row.dataset.spi);
            if (!cell) return;
            cell.textContent = '';
            if (!spi || !sw || !sh) { cell.textContent = '—'; return; }
            const dw = (sw / spi) * 2.54;
            const dh = (sh / spi) * 2.54;
            const design = document.createElement('span');
            design.textContent = `${nf.format(dw)} × ${nf.format(dh)} cm`;
            const fabric = document.createElement('span');
            fabric.className = 'fh-size__fabric';
            fabric.textContent = `${fabricLabel} ${Math.ceil(dw + margin * 2)} × ${Math.ceil(dh + margin * 2)} cm`;
            cell.append(design, fabric);
          });
        };

        box.addEventListener('input', update);
        update();
      }

      initReadMore() {
        const body = this.querySelector('[data-fh-collapsible]');
        const btn = this.querySelector('[data-fh-more]');
        if (!body || !btn || body.scrollHeight <= 440) return;
        body.classList.add('is-collapsed');
        btn.hidden = false;
        btn.addEventListener('click', () => {
          const expanded = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', String(!expanded));
          body.classList.toggle('is-collapsed', expanded);
          btn.textContent = expanded ? btn.dataset.more : btn.dataset.less;
        });
      }
    }
    customElements.define('fabric-hub', FabricHub);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lanzamiento-caja-navidad-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('xmas-hero')) {
    class XmasHero extends HTMLElement {
      connectedCallback() {
        this.classList.add('is-ready');
      }
    }
    customElements.define('xmas-hero', XmasHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lanzamiento-caja-navidad"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('xmas-launch')) {
    class XmasLaunch extends HTMLElement {
      connectedCallback() {
        this.classList.add('is-ready');
        this.track = this.querySelector('[data-nx-track]');
        this.thumbs = Array.from(this.querySelectorAll('[data-nx-go]'));
        this.dots = Array.from(this.querySelectorAll('.nx-dot'));
        this.initGallery();
        this.initCart();
      }

      initGallery() {
        if (!this.track) return;
        const slides = Array.from(this.track.children);
        if (slides.length < 2) return;
        const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.thumbs.forEach((btn) => {
          btn.addEventListener('click', () => {
            const i = parseInt(btn.dataset.nxGo, 10) || 0;
            this.track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
          });
        });

        this.track.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          const w = this.track.clientWidth;
          this.track.scrollBy({ left: e.key === 'ArrowRight' ? w : -w, behavior: smooth ? 'smooth' : 'auto' });
        });

        let ticking = false;
        this.track.addEventListener('scroll', () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            ticking = false;
            const i = Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth));
            this.thumbs.forEach((b, k) => b.setAttribute('aria-current', String(k === i)));
            this.dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
          });
        }, { passive: true });
      }

      /* Añadir al carrito sin salir de la portada, usando el carrito lateral del tema si existe */
      initCart() {
        const form = this.querySelector('[data-nx-form]');
        if (!form) return;
        const btn = form.querySelector('[data-nx-add]');
        form.addEventListener('submit', (e) => {
          const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          if (!cart || typeof cart.renderContents !== 'function' || typeof cart.getSectionsToRender !== 'function' || !window.fetch) return;
          e.preventDefault();
          btn.setAttribute('aria-busy', 'true');
          btn.disabled = true;
          const fd = new FormData(form);
          fd.append('sections', cart.getSectionsToRender().map((s) => s.id));
          fd.append('sections_url', window.location.pathname);
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
          const url = (window.routes && window.routes.cart_add_url) || '/cart/add';
          fetch(url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
            .then((r) => r.json())
            .then((res) => {
              if (res.status) throw new Error(res.description || 'error');
              cart.classList.remove('is-empty');
              cart.renderContents(res);
            })
            .catch(() => form.submit())
            .finally(() => {
              btn.removeAttribute('aria-busy');
              btn.disabled = false;
            });
        });
      }
    }
    customElements.define('xmas-launch', XmasLaunch);
  }

  } catch(e) { console.error(e); }
})();
})();
